// extracted by mini-css-extract-plugin
module.exports = {"root":"Item_root__2kpmW","value":"Item_value__3Mhom","min":"Item_min__u8ioH","icon":"Item_icon__33XwL","name":"Item_name__3Y5A_"};